import { render } from "./TableItem.vue?vue&type=template&id=445d0ed1&scoped=true&ts=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"

import "./TableItem.vue?vue&type=style&index=0&id=445d0ed1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mamo\\Desktop\\Dev\\hotaru_theme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445d0ed1"]])

export default __exports__